import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import React from 'react'
import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'

import CartSubContent from '../Cart/CartSubContent'

interface IconLinkProps {
  url: string
  title: string
  iconColor?: string
}

export const IconLink: React.FC<IconLinkProps> = ({ url = '', title = '', iconColor }) => {
  return (
    <CompatibleLink href={url} className="flex flex-row items-center" target="_blank">
      <IonIcon
        name="globe-outline"
        className={cn(`text-[1.5rem] mr-[0.625rem] ${iconColor && `text-[${iconColor}]`}`)}
      />
      <div className="cursor-pointer font-primary text-[16px] font-bold color-lthblue">
        <CartSubContent>{title}</CartSubContent>
      </div>
    </CompatibleLink>
  )
}
